import React from "react";
import { Button, CircularProgress } from "@mui/material";
import { formatPreFinanceDisplayCode } from "../utils/preFinanceCodeUtils";

const PreFinanceCodeLink = ({
  preFinanceId,
  preFinanceCode,
  isLegacy = false,
  onOpen,
  isLoading = false,
  disabled = false,
}) => {
  if (!preFinanceId || preFinanceId <= 0) {
    return null;
  }

  const displayCode = formatPreFinanceDisplayCode({ preFinanceId, preFinanceCode, isLegacy });

  const handleClick = (event) => {
    event.stopPropagation();
    onOpen?.(preFinanceId);
  };

  const handleKeyDown = (event) => {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    onOpen?.(preFinanceId);
  };

  return (
    <Button
      variant="text"
      size="small"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled || isLoading}
      aria-label={`View prefinance dossier ${displayCode}`}
      sx={{ fontFamily: "monospace", minWidth: 0, px: 0.5 }}
    >
      {isLoading ? <CircularProgress size={14} aria-label="Loading dossier" /> : displayCode}
    </Button>
  );
};

export default PreFinanceCodeLink;
